import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import './AddProduct.css';

export default function AddProduct() {
  const { user, isAdmin, refreshUserRole } = useAuth(); // Add refreshUserRole
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  
  console.log('AddProduct - User:', user?.email);
  console.log('AddProduct - IsAdmin:', isAdmin);
  
  const [affiliateLink, setAffiliateLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [productPreview, setProductPreview] = useState(null);
  const [editMode, setEditMode] = useState(false);
  
  // Placeholder image data URL
  const placeholderImage = "data:image/svg+xml,%3Csvg width='300' height='300' viewBox='0 0 300 300' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='300' height='300' fill='%23f0f0f0'/%3E%3Crect x='50' y='50' width='200' height='200' fill='%23e0e0e0' stroke='%23ccc' stroke-width='2'/%3E%3Ccircle cx='100' cy='120' r='20' fill='%23ccc'/%3E%3Cpath d='M70 160 Q150 120 230 160' fill='%23ccc'/%3E%3Ctext x='150' y='200' text-anchor='middle' fill='%23999' font-family='Arial, sans-serif' font-size='14'%3ENo Image%3C/text%3E%3Ctext x='150' y='220' text-anchor='middle' fill='%23999' font-family='Arial, sans-serif' font-size='12'%3EPaste image URL above%3C/text%3E%3C/svg%3E";

  const extractAmazonASIN = (url) => {
    // Extract ASIN from various Amazon URL formats
    const patterns = [
      /\/dp\/([A-Z0-9]{10})/i,
      /\/product\/([A-Z0-9]{10})/i,
      /\/gp\/product\/([A-Z0-9]{10})/i,
      /asin[=\/]([A-Z0-9]{10})/i,
      /\/([A-Z0-9]{10})(?:\/|$)/i
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        return match[1];
      }
    }
    return null;
  };

  const fetchProductDetails = async (asin) => {
    try {
      // Try multiple CORS proxy services
      const amazonUrl = `https://www.amazon.in/dp/${asin}`;
      console.log('Attempting frontend fetch for ASIN:', asin);
      
      // Try multiple proxy services
      const proxyServices = [
        `https://api.allorigins.win/raw?url=${encodeURIComponent(amazonUrl)}`,
        `https://corsproxy.io/?${encodeURIComponent(amazonUrl)}`,
        `https://cors-anywhere.herokuapp.com/${amazonUrl}`,
        `https://thingproxy.freeboard.io/fetch/${encodeURIComponent(amazonUrl)}`
      ];
      
      let html = '';
      let workingProxy = '';
      
      for (const proxyUrl of proxyServices) {
        try {
          console.log('Trying proxy:', proxyUrl.split('/')[2]); // Show just the domain
          const response = await fetch(proxyUrl, {
            method: 'GET',
            headers: {
              'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
              'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36'
            }
          });
          
          if (response.ok) {
            html = await response.text();
            workingProxy = proxyUrl.split('/')[2];
            console.log('✅ Success with proxy:', workingProxy);
            console.log('HTML length:', html.length);
            break;
          }
        } catch (proxyError) {
          console.log('❌ Proxy failed:', proxyUrl.split('/')[2], proxyError.message);
          continue;
        }
      }
      
      if (!html) {
        throw new Error('All proxies failed');
      }
      
      // Extract product information from HTML
      const titleMatch = html.match(/<title[^>]*>([^<]+)<\/title>/i);
      const title = titleMatch ? titleMatch[1].replace(/Amazon\.in.*?:\s*/, '').replace(/\s*-\s*Amazon\.in.*$/, '').trim() : 'Product Title';
      
      // Try multiple price patterns
      const pricePatterns = [
        /"priceAmount":"([\d,\.]+)"/i,
        /"displayPrice":"([\d,\.]+)"/i,
        /₹\s*([\d,\.]+)/i,
        /"price":\s*"([\d,\.]+)"/i,
        /data-asin-price="([^"]+)"/i
      ];
      
      let price = 0;
      for (const pattern of pricePatterns) {
        const priceMatch = html.match(pattern);
        if (priceMatch) {
          price = parseFloat(priceMatch[1].replace(/[,\s]/g, ''));
          break;
        }
      }
      
      // Try multiple image patterns
      const imagePatterns = [
        /"landingImage":"([^"]+)"/i,
        /<img[^>]*id="landingImage"[^>]*src="([^"]+)"/i,
        /"mainImage":"([^"]+)"/i,
        /data-a-hires="([^"]+)"/i
      ];
      
      let image = '';
      for (const pattern of imagePatterns) {
        const imageMatch = html.match(pattern);
        if (imageMatch) {
          image = imageMatch[1].replace(/\\\//g, '/');
          break;
        }
      }
      
      // Try multiple rating patterns
      const ratingPatterns = [
        /"rating":"([\d\.]+)"/i,
        /(\d\.?\d*)\s*out of\s*5/i,
        /"averageStarRating":"([\d\.]+)"/i,
        /data-asin-rating="([^"]+)"/i
      ];
      
      let rating = 0;
      for (const pattern of ratingPatterns) {
        const ratingMatch = html.match(pattern);
        if (ratingMatch) {
          rating = parseFloat(ratingMatch[1]);
          break;
        }
      }
      
      const extractedData = {
        asin: asin,
        title: title,
        price: price,
        image: image,
        platform: 'Amazon',
        rating: rating,
        category: 'General'
      };
      
      console.log('✅ Extracted product data:', extractedData);
      console.log('📊 Extraction summary:', {
        title: title.length > 0 ? '✅' : '❌',
        price: price > 0 ? '✅' : '❌', 
        image: image.length > 0 ? '✅' : '❌',
        rating: rating > 0 ? '✅' : '❌'
      });
      
      return extractedData;
      
    } catch (error) {
      console.error('❌ Frontend fetch failed:', error);
      throw new Error('SCRAPING_FAILED');
    }
  };

  const handlePreview = () => {
    if (!affiliateLink.trim()) {
      setError('Please enter an affiliate link');
      return;
    }

    setError('');
    setSuccess('');
    setEditMode(true);

    setProductPreview({
      asin: '',
      title: '',
      price: 0,
      image: '',
      platform: 'Amazon',
      rating: 0,
      category: '',
      affiliateLink: affiliateLink
    });

    setSuccess('Enter product details manually below.');
  };

  const handleAddProduct = async () => {
    if (!productPreview) {
      setError('Please preview the product first');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Get auth token
      const currentUser = user;
      if (!currentUser) {
        throw new Error('User not authenticated');
      }
      const loginResponse = await fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/google-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: currentUser.email,
          googleId: currentUser.uid
        })
      });

      if (!loginResponse.ok) {
        throw new Error('Failed to authenticate');
      }

      const loginData = await loginResponse.json();
      const token = loginData.token;

      // Add product to database
      const productData = {
        title: productPreview.title,
        price: productPreview.price,
        image: productPreview.image,
        affiliateLink: productPreview.affiliateLink,
        platform: productPreview.platform || 'Amazon',
        rating: productPreview.rating || 0,
        category: productPreview.category || 'General',
        externalId: productPreview.asin,
        dealEndTime: null
      };


      const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/products/add`, {

        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(productData)
      });

      if (!response.ok) {
        throw new Error('Failed to add product');
      }

      const result = await response.json();
      setSuccess('Product added successfully!');
      
      // Reset form
      setAffiliateLink('');
      setProductPreview(null);
      
      // Navigate to products page after 2 seconds
      setTimeout(() => {
        navigate('/');
      }, 2000);
      
    } catch (error) {
      console.error('Error adding product:', error);
      setError('Failed to add product. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return (
      <div className={`add-product ${darkMode ? "dark" : ""}`}>
        <div className="container">
          <div className="auth-required">
            <h2>Authentication Required</h2>
            <p>Please login to add products.</p>
            <button onClick={() => navigate('/login')} className="login-btn">
              Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className={`add-product ${darkMode ? "dark" : ""}`}>
        <div className="container">
          <div className="auth-required">
            <h2>Admin Access Required</h2>
            <p>Only administrators can add products to the catalog.</p>
            <p>Current user: {user?.email} | Role: {isAdmin ? "Admin" : "User"}</p>
            <button onClick={() => refreshUserRole()} className="login-btn" style={{marginRight: '10px'}}>
              Refresh Role
            </button>
            <button onClick={() => navigate('/')} className="login-btn">
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`add-product ${darkMode ? "dark" : ""}`}>
      <div className="container">
        <h1>Add Product via Affiliate Link</h1>
        <p className="description">
          Enter an Amazon affiliate link to automatically fetch product details and add it to the catalog.
        </p>

        <div className="form-section">
          <div className="input-group">
            <label htmlFor="affiliate-link">Amazon Affiliate Link:</label>
            <input
              id="affiliate-link"
              type="url"
              value={affiliateLink}
              onChange={(e) => setAffiliateLink(e.target.value)}
              placeholder="https://www.amazon.in/dp/B08N5WRWNW?tag=your-tag-21"
              className={`affiliate-input ${darkMode ? "dark" : ""}`}
            />
            <small className="help-text">
              Supported formats: Amazon product links, /dp/, /gp/product/, /product/ URLs
            </small>
          </div>

          <div className="button-group">
            <button
              onClick={handlePreview}
              disabled={loading || !affiliateLink.trim()}
              className="preview-btn"
            >
              {loading ? 'Fetching...' : 'Preview Product'}
            </button>
          </div>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {success && (
          <div className="success-message">
            {success}
          </div>
        )}

        {productPreview && (
          <div className="product-preview">
            <h2>Product Preview {editMode && <span className="edit-badge">✏️ Edit Mode</span>}</h2>
            {console.log('Rendering product preview:', productPreview)}
            <div className="preview-card">

              <div className="preview-image">
                <img
                  src={productPreview.image || placeholderImage}
                  alt={productPreview.title}
                  onError={(e) => {
                    e.target.src = placeholderImage;
                  }}
                />
              </div>

              <div className="preview-details">

                {editMode ? (
                  <>
                    <input
                      type="text"
                      placeholder="Product Title"
                      onChange={(e) =>
                        setProductPreview({ ...productPreview, title: e.target.value })
                      }
                      className="edit-input"
                    />
                    <input
                      type="text"
                      placeholder="Product Image URL"
                      onChange={(e) =>
                        setProductPreview({ ...productPreview, image: e.target.value })
                      }
                      className="edit-input"
                    />
                  </>
                ) : (
                  <h3>{productPreview.title}</h3>
                )}

                <div className="preview-meta">
                  {editMode ? (
                    <input
                      type="number"
                      placeholder="Price"
                      onChange={(e) =>
                        setProductPreview({
                          ...productPreview,
                          price: parseFloat(e.target.value) || 0
                        })
                      }
                      className="edit-input price-input"
                      min="0"
                      step="0.01"
                    />
                  ) : (
                    <span className="price">₹{productPreview.price}</span>
                  )}

                  <span className="platform">
                    {productPreview.platform || 'Amazon'}
                  </span>

                  {editMode ? (
                    <input
                      type="number"
                      placeholder="Rating"
                      onChange={(e) =>
                        setProductPreview({
                          ...productPreview,
                          rating: parseFloat(e.target.value) || 0
                        })
                      }
                      className="edit-input rating-input"
                      min="0"
                      max="5"
                      step="0.1"
                    />
                  ) : (
                    productPreview.rating && (
                      <span className="rating">⭐ {productPreview.rating}</span>
                    )
                  )}

                  {editMode ? (
                    <input
                      type="text"
                      placeholder="Category"
                      onChange={(e) =>
                        setProductPreview({
                          ...productPreview,
                          category: e.target.value
                        })
                      }
                      className="edit-input category-input"
                    />
                  ) : (
                    productPreview.category && (
                      <span className="category">{productPreview.category}</span>
                    )
                  )}
                </div>

                <div className="preview-link">
                  <a
                    href={productPreview.affiliateLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Product
                  </a>
                </div>

                <div className="preview-actions">
                  {editMode ? (
                    <button
                      onClick={() => setEditMode(false)}
                      className="done-editing-btn"
                    >
                      Done Editing
                    </button>
                  ) : (
                    <button
                      onClick={() => setEditMode(true)}
                      className="done-editing-btn"
                    >
                      Edit Product
                    </button>
                  )}

                  <button
                    onClick={handleAddProduct}
                    disabled={loading}
                    className="add-product-btn"
                  >
                    {loading ? 'Adding...' : 'Add Product to Catalog'}
                  </button>
                </div>

              </div>

            </div>
          </div>
        )}

        <div className="help-section">
          <h3>How to use:</h3>
          <ol>
            <li>Copy any Amazon product link (from search results, product page, etc.)</li>
            <li>Paste it in the input field above</li>
            <li>Click "Preview Product" to fetch details automatically</li>
            <li>If scraping fails, edit mode activates automatically</li>
            <li>Edit product details: title, price, category, rating, and paste image URL</li>
            <li>Click "Done Editing" when finished, then "Add Product to Catalog"</li>
          </ol>
          <p>
            <strong>Tips:</strong> You can paste any public image URL (Amazon, manufacturer site, etc.) 
            for the product image when in edit mode.
          </p>
          <p>
            <strong>Note:</strong> The system will automatically extract product information 
            including title, price, image, and other details from Amazon.
          </p>
        </div>
      </div>
    </div>
  );
}
